import "aos/dist/aos.css";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Products from "../components/Products";
import Services from "../components/Services";
import TechStack from "../components/TechStack";
import Porfolio from "../components/Porfolio";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <div className="font-sans bg-black text-white min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Products />
        <TechStack />
        <Porfolio />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
